import { useMemo } from "react";
import { View } from "react-native";
import { getShadow } from "../../utils";
import { DropShadowProps } from "./DropShadow";

export const DropShadow = ({
    style,
    shadowLevel = 32,
    shadowOpacity = 0.2,
    ...props
}: DropShadowProps) => {
    const dropShadow = useMemo(() => {
        const { shadowOffset, shadowColor, shadowRadius } = getShadow({
            level: shadowLevel,
            direction: "center",
        });

        return `drop-shadow(${shadowOffset.width}px ${shadowOffset.height}px ${shadowRadius}px ${shadowColor}) opacity(0.45)`;
    }, [shadowLevel]);

    return (
        <View
            style={[
                style,
                {
                    filter: dropShadow,
                    opacity: shadowOpacity * 8,
                    // padding: 100,
                    // boxSizing: "content-box",
                },
            ]}
            {...props}
        />
    );
};
